import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ColorPickerEditor from 'common/components/ColorPicker';
import FontPickerEditor from 'common/components/FontPicker';

import {
    setFormFieldsInputFont,
    setFormFieldsInputFontSize,
    setFormFieldsInputAnswerColor,
    setFormFieldsInputPlaceholderColor,
} from 'common/entities/form/styleConfiguration/actions';
import {
    DEFAULT_FONT,
    DEFAULT_FORM_FIELD_FONT_SIZE,
    DEFAULT_INPUT_ANSWER_COLOR,
    DEFAULT_INPUT_PLACEHOLDER_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import { getFormInputTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';
import { getFormId } from '../../../../selectors';
import { ANSWER_COLOR_LABEL, PLACEHOLDER_COLOR_LABEL } from '../../../../constants/formStyleLabels';

import { FORM_FIELDS_QA } from '../../../../utils/qaIdConstants';

const InputTextPanel = ({ formId, font, fontSize, answerColor, placeholderColor, colorList, fontList, ...props }) => (
    <React.Fragment>
        <FontPickerEditor
            fontFamilyList={fontList}
            defaultFontFamily={font}
            onChangeFontFamily={(id) => props.setFormFieldsInputFont(formId, id)}
            defaultFontSize={fontSize}
            onChangeFontSize={(size) => props.setFormFieldsInputFontSize(formId, size)}
            fontFamilyQa={`${FORM_FIELDS_QA}--fontFamily`}
            fontSizeQa={`${FORM_FIELDS_QA}--fontSize`}
        />
        <ColorPickerEditor
            colorList={colorList}
            firstColor={answerColor}
            firstColorLabel={ANSWER_COLOR_LABEL}
            changeFirstColor={(id) => props.setFormFieldsInputAnswerColor(formId, id)}
            secondColor={placeholderColor}
            secondColorLabel={PLACEHOLDER_COLOR_LABEL}
            changeSecondColor={(id) => props.setFormFieldsInputPlaceholderColor(formId, id)}
            qaId={FORM_FIELDS_QA}
        />
    </React.Fragment>
);

InputTextPanel.propTypes = {
    answerColor: styleShapePropTypes,
    placeholderColor: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.number,
    formId: PropTypes.string.isRequired,
    colorList: PropTypes.arrayOf(PropTypes.object).isRequired,
    fontList: PropTypes.arrayOf(PropTypes.object).isRequired,
    setFormFieldsInputFont: PropTypes.func.isRequired,
    setFormFieldsInputFontSize: PropTypes.func.isRequired,
    setFormFieldsInputAnswerColor: PropTypes.func.isRequired,
    setFormFieldsInputPlaceholderColor: PropTypes.func.isRequired,
};

InputTextPanel.defaultProps = {
    answerColor: getDefaultStyle(DEFAULT_INPUT_ANSWER_COLOR),
    placeholderColor: getDefaultStyle(DEFAULT_INPUT_PLACEHOLDER_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_FORM_FIELD_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const colorList = getColors(state);
    const fontList = getFonts(state);
    const { colors, font, fontSize } = getFormInputTextStyles(state, formId);

    return {
        formId,
        answerColor: colors.answer,
        placeholderColor: colors.placeholder,
        font,
        fontSize,
        colorList,
        fontList,
    };
};

const mapDispatchToProps = {
    setFormFieldsInputFont,
    setFormFieldsInputFontSize,
    setFormFieldsInputAnswerColor,
    setFormFieldsInputPlaceholderColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(InputTextPanel);
